//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import layer from '@/components/layer/layer.vue'
import BScroll from 'better-scroll'

    export default {
        name:'Zdialog',
        data(){
            return {
              showFlag:false,
              planBScroll:null,
              content:'',
            }
        },
        components: {
          layer,
        },
        props: {
          title: {
            type: [Boolean,String], //弹框标题
            default:false   
          },
          position:{
            type: [String],  // 弹框位置 
            default:'center'
          },
          bottomHeight:{
            type: [Object],  // 弹框高度
            default:()=>{
              return {height:'70%'}
            }
          }
        },
        mounted(){
           
        },
        methods:{
          showoast(str){
            this.showFlag = true;
            this.content = str;
            this.$nextTick(() => {
                if (!this.planBScroll) {
                    this.planBScroll = new BScroll(this.$refs.planBox, {
                        click: true,
                        scrollY: true,
                    });
                } else {
                    this.planBScroll.refresh()
                }
                
            })
          },
          close(){
            this.showFlag = false;
            this.planBScroll = null;
          }
        }
    }
